module.exports = __webpack_public_path__ + "static/media/DanceReel.9da24544.mp4";